const getters = {
  token: (state) => state.user.token,
  userInfo: (state) => state.user.userInfo,
  companys: (state) => state.user.userInfo.companys,
  login: (state) => state.user.userInfo.id > 0,
  navs: (state) => state.user.nav,
  getToken: (state) => {
    return state.user.token || window.localStorage.getItem('token');
  },
  getConfig: (state) => {
    return state.configs.config;
  },
};

export default getters;
